import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';

export interface Bar {
  id: string;
  name: string;
  address: string;
  city: string | null;
  is_online: boolean;
  latitude: number | null;
  longitude: number | null;
  phone: string | null;
  website: string | null;
  instagram: string | null;
  description: string | null;
  notes: string | null;
  image_url: string | null;
  probability: number | null;
  tv_channels: string | null;
  screens_count: number | null;
  google_rating: number | null;
  google_reviews: number | null;
  google_place_id: string | null;
  created_at: string;
}

export function useBars() {
  const [bars, setBars] = useState<Bar[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchBars = useCallback(async () => {
    setLoading(true);
    try {
      const { data, error } = await supabase
        .from('bars')
        .select('*')
        .order('name');
      if (error) throw error;
      setBars(data || []);
    } catch (err) {
      console.error('Fetch bars error:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchBars();
  }, [fetchBars]);

  const createBar = async (bar: Partial<Bar>) => {
    const { error } = await supabase.from('bars').insert(bar);
    if (error) throw error;
    await fetchBars();
  };

  const updateBar = async (id: string, updates: Partial<Bar>) => {
    const { error } = await supabase.from('bars').update(updates).eq('id', id);
    if (error) throw error;
    await fetchBars();
  };

  const deleteBar = async (id: string) => {
    await supabase.from('diffusions').delete().eq('bar_id', id);
    const { error } = await supabase.from('bars').delete().eq('id', id);
    if (error) throw error;
    await fetchBars();
  };

  return { bars, loading, refetch: fetchBars, createBar, updateBar, deleteBar };
}
